import { render, staticRenderFns } from "./CxCDetail.vue?vue&type=template&id=7333f7c0&scoped=true"
import script from "./CxCDetail.vue?vue&type=script&lang=js"
export * from "./CxCDetail.vue?vue&type=script&lang=js"
import style0 from "./CxCDetail.vue?vue&type=style&index=0&id=7333f7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333f7c0",
  null
  
)

export default component.exports